import { SvgIcon, SvgIconProps } from '@mui/material';
import bkashSvg from './bkash.svg';

const BkashIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <image href={bkashSvg} width='100%' height='100%' />
  </SvgIcon>
);

export default BkashIcon;
